export default __webpack_public_path__ + "static/media/fridge1-before2-480w.b4600672.webp";